import React from 'react';
import Icon from '../../../components/AppIcon';

const QuickStats = ({ stats }) => {
  const statItems = [
    {
      label: 'Total Incidents',
      value: stats?.total,
      icon: 'FileText',
      color: 'text-foreground'
    },
    {
      label: 'Critical',
      value: stats?.critical,
      icon: 'AlertTriangle',
      color: 'text-error'
    },
    {
      label: 'High Priority',
      value: stats?.high,
      icon: 'TrendingUp',
      color: 'text-warning'
    },
    {
      label: 'In Progress',
      value: stats?.inProgress,
      icon: 'Clock',
      color: 'text-accent'
    },
    {
      label: 'Resolved Today',
      value: stats?.resolvedToday,
      icon: 'CheckCircle',
      color: 'text-success'
    }
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-6">
      {statItems?.map((item, index) => (
        <div
          key={index}
          className="bg-card border border-border rounded-lg p-4 hover:shadow-medium transition-shadow duration-200"
        >
          <div className="flex items-center justify-between mb-2">
            <Icon name={item?.icon} size={20} className={item?.color} />
            <span className={`text-2xl font-semibold ${item?.color}`}>
              {item?.value?.toLocaleString()}
            </span>
          </div>
          <p className="text-sm text-muted-foreground">{item?.label}</p>
        </div>
      ))}
    </div>
  );
};

export default QuickStats;